<template>
  <div>
    <footer id="copy">
      <p>
        <a href="https://35s.co.jp/"
          target="_blank">COPYRIGHT&nbsp;©&nbsp;CHUKYO&nbsp;TV.&nbsp;SERVICE.&nbsp;ALL&nbsp;RIGHTS&nbsp;RESERVED.</a>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>